import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ContactNode } from '@syfo/types/adviser.types';

interface UpdateAdviserContactParams {
  uuid: string;
  contact: ContactNode;
}

/**
 * Update adviser contact information
 */
export const updateAdviserContactThunk = createAsyncThunk<
  void,
  UpdateAdviserContactParams
>(
  'advisers/updateContact',
  async ({ uuid, contact }) => {
    console.log(`[Advisers] Updating contact for adviser ${uuid}...`);

    const response = await fetch(`/api/advisers/${uuid}/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(contact)
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Adviser not found');
      }
      const errorText = await response.text();
      console.error(`[Advisers] Failed with status ${response.status}: ${errorText}`);
      throw new Error(`Failed to update adviser contact: ${response.status}`);
    }

    console.log('[Advisers] Contact updated successfully');
  }
);
